import _Object$assign from "@babel/runtime-corejs2/core-js/object/assign";
var common = {
  reset: '重置',
  cancel: '取消',
  confirm: '确定',
  noData: '暂无数据',
  noSearchResult: '暂无搜索结果'
};
export default {
  ImageEdit: {
    reset: '重置',
    cancel: '取消',
    confirm: '确定',
    replace: '更换',
    imageUpload: '上传图片',
    picturePreview: '图片预览',
    imgClearVisible: '※ 请确保图片清晰可见',
    imgScale: '按比例裁剪',
    zoomIn: '放大',
    zoomOut: '缩小',
    rotateLeft: '旋转',
    cropSize: '当前裁剪尺寸'
  },
  Empty: {
    text: common.noData
  },
  LineFold: {
    collapse: '收起',
    expand: '展开'
  },
  OrganizationPicker: _Object$assign(_Object$assign({}, common), {
    prompt: '提示',
    fail: '获取失败',
    chosen: '您已选择',
    items: '项',
    click: '点击查看',
    org: '组织结构',
    chose: '选择组织结构',
    search: '搜索组织结构',
    pleaseChose: '请选择',
    searchContent: '搜索内容',
    loading: '正在加载',
    chosenItems: '已选项',
    empty: '清空所选',
    city: '城市',
    cityGroup: '城市组'
  }),
  Evaluation: {
    title: '以上功能是否对您有帮助？',
    likeDesc: '很赞，鼓励一下',
    dislikeDesc: '不好，继续优化',
    feedbackDesc: '提点意见'
  },
  MultiTableSelector: _Object$assign(_Object$assign({}, common), {
    rightText: '已选数据',
    labelText: '请输入',
    search: '查询'
  }),
  MultiTabSelector: _Object$assign(_Object$assign({}, common), {
    maxSelected: '最多可选择',
    ge: '个',
    choose: '已选',
    empty: '清空已选',
    chooseAll: '全选',
    labelText: '请输入',
    confirmEmpty: '确定清空'
  }),
  CountDown: {
    confirm: '确认',
    second: '秒'
  },
  DateSelect: {
    customBtnText: "自定义",
    leftRadioText: ['昨日', '近7日', '近30日', '本月'],
    DefaultRightSelectorText: ['按日', '按周', '按月']
  }
};